export default "__VITE_ASSET__BwVKH_TB__"